export const useHour = () => {
  const curDate = new Date()
  const hour = curDate.getHours()
  const minutes = curDate.getMinutes()
  return `${hour}:${String(minutes).length === 1 ? `${0}${minutes}` : minutes}`
}